import type { Point, Stroke, StrokeInput } from '@twitch-draw/shared';

export function renderStroke(
  ctx: CanvasRenderingContext2D,
  points: Point[],
  color: string,
  width: number,
  canvasWidth: number,
  canvasHeight: number
): void {
  if (points.length < 2) return;

  ctx.beginPath();
  ctx.strokeStyle = color;
  ctx.lineWidth = width;
  ctx.lineCap = 'round';
  ctx.lineJoin = 'round';

  const [startX, startY] = points[0];
  ctx.moveTo(startX * canvasWidth, startY * canvasHeight);

  for (let i = 1; i < points.length; i++) {
    const [x, y] = points[i];
    ctx.lineTo(x * canvasWidth, y * canvasHeight);
  }

  ctx.stroke();
}

export function renderStrokes(
  ctx: CanvasRenderingContext2D,
  strokes: Stroke[],
  canvasWidth: number,
  canvasHeight: number
): void {
  for (const stroke of strokes) {
    renderStroke(ctx, stroke.points, stroke.color, stroke.width, canvasWidth, canvasHeight);
  }
}

export function renderCurrentStroke(
  ctx: CanvasRenderingContext2D,
  stroke: StrokeInput | null,
  canvasWidth: number,
  canvasHeight: number
): void {
  if (!stroke) return;
  renderStroke(ctx, stroke.points, stroke.color, stroke.width, canvasWidth, canvasHeight);
}

export function clearCanvas(ctx: CanvasRenderingContext2D): void {
  ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
}

export function normalizeCoordinates(
  clientX: number,
  clientY: number,
  canvas: HTMLCanvasElement
): Point {
  const rect = canvas.getBoundingClientRect();
  const x = (clientX - rect.left) / rect.width;
  const y = (clientY - rect.top) / rect.height;

  return [
    Math.max(0, Math.min(1, x)),
    Math.max(0, Math.min(1, y)),
  ];
}
